import { z } from 'zod';
import { baseFESchema } from '../base.domain.js';
import { objectIdSchema, isValidObjectIdSchema } from '../../utils/index.js';
import { QuestionType } from './structure/base.structure.js';

const questionDraftSchema = baseFESchema.extend({
  time: z.number().optional(),
  type: z.nativeEnum(QuestionType).optional(),
  parent: objectIdSchema.optional(),
  structure: z.record(z.string(), z.any()).optional(),
  index: z.number().int(),
  edited: z.boolean().optional(),
  deleted: z.boolean().optional(),
  topics: z.array(z.string()).optional(),
  standardIds: z.array(z.unknown()).optional(),
  isSuperParent: z.boolean().nullable().default(false).optional(),
  teleportFrom: isValidObjectIdSchema.optional()
});
const questionDraftFESchema = questionDraftSchema.extend({
  parent: isValidObjectIdSchema.optional(),
  standardIds: z.array(z.unknown()).optional()
});

export { questionDraftFESchema, questionDraftSchema };
